import { render } from "./PassingCreateForm.vue?vue&type=template&id=3258a1a4&scoped=true"
import script from "./PassingCreateForm.vue?vue&type=script&lang=js"
export * from "./PassingCreateForm.vue?vue&type=script&lang=js"

import "./PassingCreateForm.vue?vue&type=style&index=0&id=3258a1a4&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3258a1a4"]])

export default __exports__